<template>
  <div v-show="show" class="count-down">
    <div v-if="remainTitle" class="tag">{{ remainTitle }}</div>
    <div class="time">
      <div class="time-item">{{ time.h }}</div>
      <div class="semi">:</div>
      <div class="time-item">{{ time.m }}</div>
      <div class="semi">:</div>
      <div class="time-item">{{ time.s }}</div>
    </div>
  </div>
</template>

<script>
import { getCustomWrapperId } from '@/utils/math'
import countDownUtil from '../countDown/utils'
export default {
  props: {
    remainTitle: {
      type: String,
      default: ''
    },
    remainTime: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      time: {
        h: 0,
        m: 0,
        s: 0
      },
      countDownId: null,
      show: false
    }
  },
  created() {},
  mounted() {
    this.countDownId = getCustomWrapperId('cart-down')
    const seconds = this.remainTime || 0
    countDownUtil.addCountDown(this.countDownId, seconds, remainingSeconds => {
      if (!remainingSeconds) {
        countDownUtil.removeCountDown(this.countDownId)
        this.show = false
      } else {
        const formattedTime = this.formatTime(remainingSeconds)
        this.time = formattedTime
        const countDown =
          this.time.h === '00' && this.time.m === '00' && this.time.s === '00'
        const hasTime = !!this.time.h && !!this.time.m && !!this.time.s

        if (countDown && !hasTime) {
          this.show = false
        } else {
          this.show = true
        }
      }
    })
  },
  beforeDestroy() {
    countDownUtil.removeCountDown(this.countDownId)
  },
  methods: {
    formatTime(totalSeconds) {
      const h = Math.floor(totalSeconds / 3600)
      const m = Math.floor((totalSeconds % 3600) / 60)
      const s = totalSeconds % 60
      return {
        h: h < 10 ? '0' + h : h,
        m: m < 10 ? '0' + m : m,
        s: s < 10 ? '0' + s : s
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.count-down {
  @include flex(row, center, center);
  width: 100%;
  height: 25px;
  background: #ffece8;
  border-radius: 0 0 6px 6px;
  padding-right: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  .tag {
    font-weight: 600;
    font-size: 12px;
    color: #f03100;
    line-height: 25px;
    margin-right: 2px;
  }
  .time {
    @include flex(row, center, center);
    &-item {
      width: 16px;
      height: 16px;
      background: #f03100;
      text-align: center;
      line-height: 16px;
      border-radius: 4px;
      font-weight: 600;
      font-size: 11px;
      color: #ffffff;
    }
  }
  .semi {
    font-weight: 600;
    font-size: 11px;
    @include text-line-height;
    color: #f03100;
    padding: 0 1px;
  }
}
</style>
